export interface Award {
  title: string;
  organization: string;
  date: string;
  description: string;
  project?: string;
}

export const awards: Award[] = [
  {
    title: '대상',
    organization: 'CMC 12th',
    date: '2024',
    description: 'Runway 프로젝트로 수상',
    project: 'Runway'
  },
  {
    title: '우수상',
    organization: 'UMC 3rd',
    date: '2024',
    description: 'Lifolio 프로젝트로 수상',
    project: 'Lifolio'
  },
  {
    title: '장려상',
    organization: '핀테크 공모전',
    date: '2024',
    description: '핀테크 분야 공모전 수상'
  }
];
